<template>
  <v-hover v-slot="{ hover }">
    <v-card
      :elevation="hover ? 16 : 2"
      :class="[`degree-${judgement.caseSourceId}`,{ 'on-hover': hover }]"
      @click="$emit('judgement-card-click',judgement)"
    >
        <div class="d-flex font-weight-black header-text">
            <div class="pa-3 ml-auto text-c-dark">
                <v-icon large
                        color="var(--app-primary-color)"
                        class="ml-3">
                    {{'mdi-gavel'}}
                </v-icon>
                <span class="case-update-card-header"> {{ judgement.judgementType }}</span>
            </div>
            <div v-if="hasActions"
                 class="mt-2">
                <slot name="actions"
                      :item="judgement" />
            </div>
            <div v-if="isNonFinalJudgement && (hasObjectionRequest || judgement.remainingObjectionDays > 0)" class="pa-2">
                <slot>
                    <v-hover v-slot:default="{ hover }">
                        <v-badge :value="hover"
                                 :content="hasObjectionRequest ? local.caseFile.cards.judgement.objectionRequestExists + judgement.objectionRequestCode : local.caseFile.cards.judgement.notExecutable "
                                 left transition="slide-x-transition">
                            <v-icon>mdi-alert-circle-outline</v-icon>
                        </v-badge>
                    </v-hover>
                </slot>

            </div>
        </div>

            <template>
                <slot name="top-slot"
                      :item="judgement" />
            </template>

            <div class="row px-2 header-text">
                <div class="py-1 text-c-green col-4">
                    {{ local.caseFile.cards.judgement.codeDisplayName }}
                </div>
                <div class="py-1  text-info-value col-8"
                     :title="judgement.judgementCode">
                    {{ judgement.judgementCode }}
                </div>
            </div>
            <div v-if="judgement.sakDate" class="row px-2 header-text">
                <div class="py-1 text-c-green col-4">
                    {{ local.caseFile.cards.judgement.dateDisplayName }}
                </div>
                <div class="py-1  text-info-value col-8"
                     :title="judgement.sakDate">
                    {{ toHijriDate(judgement.sakDate) }}
                </div>
            </div>
            <div class="row px-2 header-text">
                <div class="py-1  text-c-green col-4">
                    {{ local.home.tabCommon.courtName }}
                </div>
                <div class="py-1  text-info-value col-8"
                     :title="judgement.courtName">
                    {{ judgement.courtName }}
                </div>
            </div>
            <div v-if="judgement.subCircleName" class="row px-2 header-text">
                <div class="py-1  text-c-green col-4">
                    {{ local.home.tabCommon.subCircleName }}
                </div>
                <div class="py-1  text-info-value col-8"
                     :title="judgement.subCircleName">
                    {{ judgement.subCircleName }}
                </div>
            </div>
            <template>
                <slot name="bottom-slot" :item="judgement" />
            </template>

            <v-divider class="mt-5 mb-0"></v-divider>

            <div class="d-flex justify-content-end font-weight-black text-c-green">
                <div class="px-1 pa-3 ml-auto">
                    <span :class="`degree-text-${judgement.caseSourceId}`">
                        {{ caseDegrees[judgement.caseSourceId] }}
                    </span>
                </div>
                <div v-if="isNonFinalJudgement"
                     class="px-2 pa-3">
                    {{ local.caseFile.cards.judgement.dueDateDisplayName }}
                    <span class="text-c-lite mr-1"> {{ toHijriDate(judgement.objectionDueDate) }}</span>
                </div>
            </div>
    </v-card>
  </v-hover>
</template>

<script>

import { toHijriDate } from '@/helpers/utils';
import { caseDegrees } from '@/helpers/enum';
import { createNamespacedHelpers } from 'vuex';
import NajButton from '@/components/shared/naj-button/naj-button.vue';

const {  mapActions } = createNamespacedHelpers('CasesModule');

export default {
  name: 'judgementCard',
  components: { NajButton },
        props: {
            judgement: {
                type: Object,
                required: true,
            },
            hasActions: {
                default: false,
                type: Boolean,
                required: true,
            },
  },
  data() {
    return {
      caseDegrees,
        isLoading: true,

    };
  },
  computed: {
      hasObjectionRequest() {
        return this.judgement.objectionRequestCode !== null && this.judgement.objectionRequestCode !== undefined;
      },
      isNonFinalJudgement() {
          return this.judgement.objectionDueDate && this.judgement.judgementLevelId == 2;
      }
  },
  methods: {
    ...mapActions([]),
      toHijriDate,
  },
};
</script>

<style lang="scss" scoped>
.header-text {
  font-weight: 700;
  font-size: 18px;
  color: var(--app-dark-primary-color);
}

    .text-c-green {
        color: var(--app-primary-color);
    }

.text-c-dark {
  color: var(--app-dark-primary-color);
}

.text-c-lite {
  color: #a6b8bb;
}

.text-info-value {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.degree-1 {
  border: 2px solid #97dfdf;

  .degree-text-1 {
    color: #97dfdf;
    font-size: 16px;
    font-weight: bolder;
  }
}

    .degree-2 {
        border: 2px solid var(--app-primary-color);

        .degree-text-2 {
            color: var(--app-primary-color);
            font-size: 16px;
            font-weight: bolder;
        }
    }

.degree-3 {
  border: 2px solid var(--app-dark-primary-color);

  .degree-text-3 {
    color: var(--app-dark-primary-color);
    font-size: 16px;
    font-weight: bolder;
  }
}
.watermark-bg {
            color: lightgrey;
            font-size: 40px;
            transform: rotate(300deg);
            -webkit-transform: rotate(300deg);
    }
#badge {
        transition: opacity 0.4s ease-in-out;
        bottom: 10px;
        

    }

#badge:not(.on-hover) {
        opacity: 0;
}
.badge-color {
        background-color: white !important;
        color: black !important;
        border-radius: 5px;
    }

</style>